import React from 'react';
import PropTypes from 'prop-types';
import { LeftNavigationBar, DashboardNavigationLink } from '@unite-us/app-components';
import { withRouter, Link } from 'react-router';
import { AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';
import { useCurrentPayerId } from 'common/contexts/CurrentProviderContext';
import { useServiceAuthorizationStatusCount } from '../hooks/useServiceAuthorizationStatusCount';

export const StatusSelectBar = ({ router }) => {
  const payerId = useCurrentPayerId();
  const openCount = useServiceAuthorizationStatusCount(AUTHORIZATION_STATUSES.open, payerId);
  return (
    <LeftNavigationBar className="space-y-1 -mb-20">
      <DashboardNavigationLink
        className="text-base"
        label="Open"
        count={openCount}
        to="/authorizations/open"
        LinkComponent={Link}
        isActive={router && router.isActive({ pathname: '/authorizations/open' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="Accepted"
        to="/authorizations/accepted"
        LinkComponent={Link}
        isActive={router && router.isActive({ pathname: '/authorizations/accepted' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="Voided"
        to="/authorizations/voided"
        LinkComponent={Link}
        isActive={router && router.isActive({ pathname: '/authorizations/voided' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="Rejected"
        to="/authorizations/rejected"
        LinkComponent={Link}
        isActive={router && router.isActive({ pathname: '/authorizations/rejected' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="All Requests"
        to="/authorizations/all"
        LinkComponent={Link}
        isActive={router && router.isActive({ pathname: '/authorizations/all' })}
      />
    </LeftNavigationBar>
  );
};

StatusSelectBar.propTypes = {
  router: PropTypes.shape({
    isActive: PropTypes.func,
  }).isRequired,
};

export default withRouter(StatusSelectBar);
